<template>
  <b-dropdown class="dropdown-form" v-bind:class="{'color-button': (!defaultValue)}">
    <template slot="button-content">
      <i class="fas fa-bed"></i> Beds: {{ getBedNumber }}<span v-if="!defaultValue">+</span>
      <reset-button v-if="!defaultValue" v-on:x-button-clicked="resetBedNumber"></reset-button>
    </template>
    <b-dropdown-item v-for="bed in beds" v-bind:key="bed" v-on:click="updateBedNumber(bed)">{{ bed }}<span v-if="bed !== 'Any'">+</span></b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import defaultValues from '../../../../../store/lib/defaultValues.js'
import ResetButton from '../../../../general/buttons/CircleEnclosedXButton.vue'

export default {
  data () {
    return {
      beds: ['Any', '1', '2', '3', '4', '5']
    }
  },
  components: {
    ResetButton
  },
  methods: {
    ...mapMutations('homeSearch', [
      'updateBedNumber'
    ]),
    resetBedNumber () {
      this.updateBedNumber(defaultValues.bedNumber)
    }
  },
  computed: {
    ...mapGetters('homeSearch', [
      'getBedNumber'
    ]),
    defaultValue (e) {
      return this.getBedNumber === defaultValues.bedNumber
    }
  }
}
</script>

<style scoped>
.dropdown-form >>> .dropdown-item {
  color:#4f4f4f !important;
}

.color-button >>> .btn {
  background-color: #eaeaea !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeSearch/searchBar/buttons/Beds.vue